import type { ReactNode } from "react";
import type { UserInfo } from "@common/auth/session";

interface Props {
  user: UserInfo | null;
  onSignIn: () => void;
  children: ReactNode;
}

/**
 * Wraps content that needs an account. A signed-out visitor gets the sign-in
 * prompt, never a data-shaped empty state.
 */
export default function RequireAuth({ user, onSignIn, children }: Props) {
  if (!user) {
    return (
      <section className="notice">
        <p>Sign in with your kast-dev account to see this.</p>
        <button className="btn primary" onClick={onSignIn}>
          Sign in
        </button>
      </section>
    );
  }
  return <>{children}</>;
}
